import { useDictionary } from '@/shared/api/queries/useDictionary';
import type { AppSettings } from '@/shared/types';

interface UseAppSettingsDictionaryOptions {
  enabled?: boolean;
}

const useAppSettingsDictionary = ({
  enabled = true,
}: UseAppSettingsDictionaryOptions = {}) => {
  const {
    data: appSettingsData,
    isLoading: isAppSettingsLoading,
    isError: isAppSettingsError,
    error: appSettingsError,
  } = useDictionary<AppSettings>({
    dictionaryName: 'appsettings',
    enabled,
  });

  return {
    appSettingsData,
    isAppSettingsLoading,
    isAppSettingsError,
    appSettingsError,
  };
};

export { useAppSettingsDictionary };
